<div style="font-family : Helvetica;">
  <h2 mat-dialog-title> <pre style="font-size: 12pt; margin: auto!important;">{{data}}</pre></h2>
<mat-dialog-actions>
  <button mat-raised-button class="eCase-dialog-positive-action-button" (click)="close()">{{ 'okDialogText' | translate }}</button>
</mat-dialog-actions>
</div>

